import { DrawerInviteScheduleProvider } from './context/DrawerInviteScheduleContext';
import InviteSchedule from './DrawerInviteSchedule';

import { DrawerInviteScheduleProps } from './types';

const DrawerInviteSchedule: React.FC<DrawerInviteScheduleProps> = ({
  onCloseDrawer,
  openDrawerInviteCreated,
}) => {
  return (
    <DrawerInviteScheduleProvider>
      <InviteSchedule
        onCloseDrawer={onCloseDrawer}
        openDrawerInviteCreated={openDrawerInviteCreated}
      />
    </DrawerInviteScheduleProvider>
  );
};

export default DrawerInviteSchedule;
